/**
 * De twee plekken waar Facturatie de app verlaat: de PDF in een nieuw tabblad en
 * de betaalpagina van de provider. Eén object, zodat een test ze kan vervangen;
 * jsdom kan zelf niet navigeren.
 */
export const browser = {
    /**
     * Een leeg tabblad, geopend tijdens de klik zelf. Een tabblad dat pas na een
     * `await` opent, houdt de popupblokker tegen; zo vult het zich zodra de link
     * er is. `null` als de browser het toch blokkeerde.
     */
    openBlankTab(): Window | null {
        return window.open('', '_blank');
    },

    /** Stuurt een eerder geopend tabblad naar `url`, zonder terugverwijzing naar de app. */
    navigateTab(tab: Window, url: string): void {
        tab.opener = null;
        tab.location.href = url;
    },

    /** Verlaat de app, naar de betaalpagina. */
    assign(url: string): void {
        window.location.assign(url);
    },
};
